import React from 'react';
import {
  CardMedia,
  Typography,
  ListItem,
} from '@material-ui/core';
import { func, string, bool } from 'prop-types';
import '../../css/shared/ListItemCard.scss';

const ListItemCard = (props) => {
  const {
    isRead,
    isSelected,
    title,
    body,
    date,
    imageURL,
    onClick,
  } = props;

  const getListItemStyle = () => {
    if (isSelected) {
      return 'listItemCardSelected';
    }
    return 'listItemCardUnselected';
  };

  return (
    <ListItem
      className={getListItemStyle()}
      onClick={onClick}
    >
      <div className="outerCardContainer">
        <div className="titleAndSubtitleToDateSpacerContainer">
          <div className="titleAndSubtitleContainer">
            {
              !isRead && (
                <div className="listItemCardNewDot" />
              )
            }
            <Typography className="cardTitle">
              {title}
            </Typography>
            <Typography className="cardBody">
              {body}
            </Typography>
          </div>
          <Typography className="cardTime">
            {date}
          </Typography>
        </div>
        {
          Boolean(imageURL) && (
            <CardMedia
              className="cardImage"
              component="img"
              src={imageURL}
            />
          )
        }
      </div>
    </ListItem>
  );
};

ListItemCard.propTypes = {
  onClick: func.isRequired,
  title: string.isRequired,
  body: string.isRequired,
  date: string.isRequired,
  imageURL: string,
  isSelected: bool,
  isRead: bool,
};

ListItemCard.defaultProps = {
  isSelected: false,
  imageURL: '',
  isRead: false,
};

export default ListItemCard;
